export function highlight(input?: string, search?: string) {
  if (!input || !search) return input
  const result = input
  const index = input?.toLocaleLowerCase().indexOf(search?.toLocaleLowerCase())

  return index >= 0 && search
    ? result.substring(0, index) +
        "<span class='highlight'>" +
        result.substring(index, index + search.length) +
        '</span>' +
        result.substring(index + search.length)
    : input
}

export function prefixHttps(url: string) {
  const protocols = ['http://', 'https://', 'ftp://', 'file://', 'mailto:', 'tel:', 'data:', 'ws://', 'wss://']
  const hasProtocol = protocols.some((protocol) => url.startsWith(protocol))
  if (!hasProtocol) {
    url = 'https://' + url
  }
  return url
}

export function stripHtmlTags(htmlString: string | undefined): string {
  return htmlString ? htmlString.replace(/<[^>]*>/g, '') : ''
}

export function sanitizeHtml(htmlString: string | undefined): string {
  if (!htmlString) return htmlString ?? ''

  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  // Remove potentially harmful elements and attributes
  const elementsToRemove = ['script', 'style', 'iframe', 'object', 'embed']
  const attributesToRemove = ['onerror', 'onload', 'onclick', 'onmouseover']

  elementsToRemove.forEach((tag) => {
    const elements = doc.getElementsByTagName(tag)
    for (let i = elements.length - 1; i >= 0; i--) {
      elements[i].parentNode?.removeChild(elements[i])
    }
  })

  const allElements = doc.getElementsByTagName('*')
  for (const element of Array.from(allElements)) {
    for (const attr of attributesToRemove) {
      element.removeAttribute(attr)
    }
  }

  // Get the sanitized HTML content
  const sanitizedHtml = doc.body.innerHTML

  return sanitizedHtml
}

export function stripHtmlTagsAndTrim(htmlString: string | undefined): string {
  return stripHtmlTags(htmlString).trim()
}
